import React from 'react';
import './VoiceAssistantUI.css';

const VoiceAssistantUI = ({ 
  state = 'idle', // idle, connecting, listening, speaking, processing, error
  onClose,
  errorMessage = 'Connection failed. Please try again.'
}) => {
  const getStatusText = () => {
    switch (state) {
      case 'connecting':
        return 'Connecting...';
      case 'listening':
        return 'Listening';
      case 'speaking':
        return 'Zoomey is speaking';
      case 'processing':
        return 'Processing...';
      case 'error':
        return errorMessage;
      default:
        return 'Ready';
    }
  };

  const getStatusIcon = () => {
    switch (state) {
      case 'connecting':
        return <i className="bi bi-wifi"></i>;
      case 'listening':
        return <i className="bi bi-mic-fill"></i>;
      case 'speaking':
        return <i className="bi bi-volume-up-fill"></i>;
      case 'processing':
        return <i className="bi bi-gear"></i>;
      case 'error':
        return <i className="bi bi-exclamation-triangle-fill"></i>;
      default:
        return <i className="bi bi-mic"></i>;
    }
  };

  return (
    <div className="voice-assistant-container">
      {/* Close button */}
      {onClose && (
        <button className="voice-close-btn" onClick={onClose}>
          <i className="bi bi-x-lg"></i>
        </button>
      )}

      {/* Main orb visualization */}
      <div className={`voice-orb-wrapper ${state}`}>
        {/* Outer rings */}
        <div className="voice-ring voice-ring-1"></div>
        <div className="voice-ring voice-ring-2"></div>
        <div className="voice-ring voice-ring-3"></div>
        
        {/* Main orb */}
        <div className={`voice-orb ${state}`}>
          {/* Inner glow */}
          <div className="voice-orb-inner"></div>
          
          {/* Center icon */}
          <div className="voice-orb-icon">
            {getStatusIcon()}
          </div>

          {/* Audio bars for listening state */}
          {state === 'listening' && (
            <div className="voice-audio-bars">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}

          {/* Pulse waves for speaking state */}
          {state === 'speaking' && (
            <div className="voice-pulse-waves">
              <div className="pulse-wave"></div>
              <div className="pulse-wave"></div>
              <div className="pulse-wave"></div>
            </div>
          )}

          {/* Rotating dots for processing */}
          {state === 'processing' && (
            <div className="voice-processing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}

          {/* Connecting animation */}
          {state === 'connecting' && (
            <div className="voice-connecting-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
      </div>

      {/* Status text */}
      <div className={`voice-status ${state}`}>
        <span className="voice-status-text">{getStatusText()}</span>
      </div>

      {/* Retry button for error state */}
      {state === 'error' && (
        <button className="voice-retry-btn" onClick={onClose}>
          <i className="bi bi-arrow-clockwise"></i>
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
};

export default VoiceAssistantUI;
